import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  const token = auth.getToken();

  const authReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || auth.initializing()) {
        return throwError(() => error);
      }
      // Пробуем silent-refresh: если токен только что истёк, не выкидываем
      // пользователя сразу.
      return from(auth.tryRefresh()).pipe(
        switchMap((refreshed) => {
          if (!refreshed) {
            auth.logout();
            return throwError(() => error);
          }
          const fresh = auth.getToken();
          const retried = fresh
            ? req.clone({ setHeaders: { Authorization: `Bearer ${fresh}` } })
            : req;
          return next(retried);
        }),
      );
    }),
  );
};
